<div class="modal-header">
  <h4 class="modal-title">Промяна на парола</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <label for="currentPassword" class="mb-0 form-label">Текуща парола*</label>
      <input
        id="currentPassword"
        type="password"
        minlength="8"
        formControlName="currentPassword"
        class="form-control"
        placeholder="Въведете парола..."
        aria-label="Текуща парола"
        [class.is-valid]="currentPassword?.touched && currentPassword?.valid"
        [class.is-invalid]="currentPassword?.touched && currentPassword?.invalid">
      <p class="invalid-feedback m-0">Задължително поле с минимална дължина от 8 символа!</p>
    </fieldset>
    <fieldset class="mb-4">
      <label for="newPassword" class="mb-0 form-label">Нова парола*</label>
      <input
        id="newPassword"
        type="password"
        minlength="8"
        formControlName="newPassword"
        class="form-control"
        placeholder="Въведете парола..."
        aria-label="Нова парола"
        [class.is-valid]="newPassword?.touched && newPassword?.valid"
        [class.is-invalid]="newPassword?.touched && newPassword?.invalid">
      <p class="invalid-feedback m-0">Задължително поле с минимална дължина от 8 символа!</p>
    </fieldset>
    <fieldset class="mb-4">
      <label for="confirmNewPassword" class="mb-0 form-label">Повторете новата парола*</label>
      <input
        id="confirmNewPassword"
        type="password"
        minlength="8"
        formControlName="confirmNewPassword"
        class="form-control"
        placeholder="Повторете паролата..."
        aria-label="Повторете паролата"
        [class.is-valid]="confirmNewPassword?.touched && confirmNewPassword?.valid && confirmNewPassword?.value === newPassword?.value"
        [class.is-invalid]="confirmNewPassword?.touched && (confirmNewPassword?.invalid || confirmNewPassword?.value !== newPassword?.value)">
      @if (confirmNewPassword?.touched && !confirmNewPassword?.valid) {
        <div class="text-danger">
          <small>Задължително поле с минимална дължина от 8 символа!</small>
        </div>
      }
      @if (confirmNewPassword?.touched && confirmNewPassword?.value !== newPassword?.value) {
        <div class="text-danger">
          <small>Паролата не съвпада!</small>
        </div>
      }
    </fieldset>
  </form>
  @if (!!errorMessage) {
    <div class="pb-2 text-danger">
      {{ errorMessage }}
    </div>
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
